const SCOPE = 'advanced-editor-panel';

export const AdvancedEditorPanelTestIds = {
  INSERT_BUTTON: `${SCOPE}.insert-button`,
  WRAP_IN_GROUP_BUTTON: `${SCOPE}.wrap-in-group-button`,
  REFORMAT_BUTTON: `${SCOPE}.reformat-button`,
  TOGGLE_OUTLINE_BUTTON: `${SCOPE}.toggle-outline-button`,
};
